<template>
  <div>
    <navigation v-if="showSideNavigation"></navigation>
    <router-view></router-view>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Navigation from "./Nav";
export default {
  components: {
    Navigation,
  },
  computed: {
    showSideNavigation() {
      const hideNavigation = this.$route.meta.disableSideNavigation;
      return this.showSideNavigationStore && !hideNavigation;
    },
    ...mapState({
      showSideNavigationStore: state => state.application.showSideNavigation,
    }),
  },
};
</script>
